import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ExtendedNgxDropdownConfig } from 'src/app/types/ngx-select-dropdown';

@Component({
  selector: 'app-custom-multi-select',
  template: `
  <div class = "mb-3">
    <label>{{to['label']}}</label>
    <ngx-select-dropdown
        [formControl]="formControl" formlyAttributes="field"  
        options="to.options"
        multiple="to['multiple']"
        config="dropdownConfig"
    ></ngx-select-dropdown>
  </div>
  `,
  standalone:true,
  imports:[
    NgxMatSelectSearchModule,ReactiveFormsModule
    
  ]
})
export class CustomMultiSelectComponent extends FieldType<FieldTypeConfig> {
    dropdownConfig: ExtendedNgxDropdownConfig = {
        search: true,
        displayKey: 'text',
        height: 'auto',
        placeholder: this.props.placeholder ? this.props.placeholder : 'Select items',
        limitTo: 0,
        moreText: '',
        noResultsFound: '',
        searchPlaceholder: '',
        searchOnKey: '',
        clearOnSelection: false,
        inputDirection: '',
        customComparator: function (a: any, b: any): number {
            if (a.name < b.name) {
                return -1;
              }
              if (a.name > b.name) {
                return 1;
              }
              return 0;
        }
    };
}
